export const GAP = 0.25;

export const box = (it) => (it.rot === 90 ? { bw: it.w * it.aspect, bh: it.w } : { bw: it.w, bh: it.w * it.aspect });

export const isOff = (it, W, L) => {
  const { bw, bh } = box(it);
  return it.x < 0 || it.y < 0 || it.x + bw > W + 0.001 || it.y + bh > L + 0.001;
};

export const usedLength = (items) => items.reduce((m, it) => Math.max(m, it.y + box(it).bh), 0);

export function pack(items, W) {
  const sorted = [...items].sort((a, b) => box(b).bh - box(a).bh);
  let x = GAP, y = GAP, row = 0;
  const placed = sorted.map((it) => {
    const { bw, bh } = box(it);
    if (x + bw > W - GAP + 0.001 && x > GAP) { x = GAP; y += row + GAP; row = 0; }
    const p = { ...it, x, y };
    x += bw + GAP;
    row = Math.max(row, bh);
    return p;
  });
  return { placed, length: y + row + GAP };
}

const overlap = (a, b) => {
  const A = box(a), B = box(b);
  return a.x < b.x + B.bw - 0.01 && b.x < a.x + A.bw - 0.01 && a.y < b.y + B.bh - 0.01 && b.y < a.y + A.bh - 0.01;
};

export const overlappingIds = (items) => {
  const ids = new Set();
  items.forEach((a, i) => items.slice(i + 1).forEach((b) => { if (overlap(a, b)) { ids.add(a.id); ids.add(b.id); } }));
  return ids;
};

export const nextSpot = (items, it, W) => {
  const { bw } = box(it);
  const ys = [...new Set([GAP, ...items.map((x) => x.y), ...items.map((x) => x.y + box(x).bh + GAP)])].sort((a, b) => a - b);
  const xs = [...new Set([GAP, ...items.map((x) => x.x + box(x).bw + GAP)])].sort((a, b) => a - b);
  for (const y of ys) {
    for (const x of xs) {
      if (x + bw > W - GAP + 0.001) continue;
      const cand = { ...it, x, y };
      if (!items.some((o) => overlap(cand, o))) return { x, y };
    }
  }
  return { x: GAP, y: (items.length ? usedLength(items) : 0) + GAP };
};

const loadImg = (src) => new Promise((res, rej) => { const i = new Image(); i.onload = () => res(i); i.onerror = rej; i.src = src; });

export async function renderGang(items, W, L, ppi = 10) {
  const c = document.createElement("canvas");
  c.width = Math.round(W * ppi);
  c.height = Math.round(L * ppi);
  const ctx = c.getContext("2d");
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, c.width, c.height);
  ctx.strokeStyle = "#e5e7eb";
  for (let i = 12; i < L; i += 12) { ctx.beginPath(); ctx.moveTo(0, i * ppi); ctx.lineTo(c.width, i * ppi); ctx.stroke(); }
  for (const it of items) {
    const img = await loadImg(it.src);
    const { bw, bh } = box(it);
    const w = it.w * ppi, h = it.w * it.aspect * ppi;
    ctx.save();
    ctx.translate((it.x + bw / 2) * ppi, (it.y + bh / 2) * ppi);
    ctx.rotate((it.rot * Math.PI) / 180);
    ctx.drawImage(img, -w / 2, -h / 2, w, h);
    ctx.restore();
  }
  return new Promise((r) => c.toBlob(r, "image/png"));
}
